import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import WhyChooseUs from "./whyChooseUs";
import FeatureList from "./serviceFeatureList";
import {
  featureListData,
  DryCleanListData,
  TailoringListData,
} from "../constants/homePageConstant";
import homeBackground from "../assets/webp/homeBackground.webp";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import AppDownloadBadges from "../component/AppDownloadBadges";

export default function Marketing() {
  const navigate = useNavigate();

  return (
    <div className="font-poppins h-[calc(100vh-80px)] mt-[80px] overflow-y-auto scrollbar-hide">
      {/* Hero - same gradient and messaging as home */}
      <div
        className="w-full py-14 md:py-20 flex justify-center items-center"
        style={{
          background:
            "linear-gradient(90deg, #02537F 0%, #0585CB 60%, #035885 100%)",
        }}
      >
        <div className="mx-4 md:mx-6 lg:mx-14 text-center max-w-4xl">
          <h1 className="text-white font-bold text-3xl md:text-5xl lg:text-6xl leading-tight mb-4">
            Laundry Made Simple
          </h1>
          <p className="text-white/90 text-lg md:text-xl max-w-2xl mx-auto mb-8">
            Fast, reliable, and on-demand. Tydii brings your clean clothes right
            to your doorstep—because your time matters.
          </p>
          <button
            type="button"
            onClick={() => navigate("/auth/account")}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-[#02537F] hover:bg-sky-50 px-6 py-3 text-base font-bold shadow-lg transition"
          >
            Get started
            <ArrowForwardOutlinedIcon className="w-5 h-5" />
          </button>
          <div className="mt-8 flex flex-col items-center">
            <p className="text-white/90 text-sm mb-3">Or download the customer app</p>
            <AppDownloadBadges appType="customer" theme="light" className="justify-center" />
          </div>
        </div>
      </div>

      {/* Value prop strip - reuse home copy */}
      <div
        className="w-full h-[164px] flex justify-center items-center"
        style={{
          background:
            "linear-gradient(90deg, #02537F 0%, #0585CB 60%, #035885 100%)",
        }}
      >
        <p className="text-white text-center text-lg md:text-xl max-w-4xl font-normal px-4">
          <span className="font-bold">TYDII</span> provides{" "}
          <span className="italic font-semibold">
            All types of Laundry Services
          </span>{" "}
          —wash & fold, dry cleaning, and tailoring—from trusted local
          providers, delivered to your door.
        </p>
      </div>

      {/* Features - reuse FeatureList */}
      <div className="mx-4 md:mx-6 lg:mx-14 py-10 md:py-16">
        <h2 className="text-2xl md:text-3xl font-bold text-[#023B64] text-center mb-2">
          How it works
        </h2>
        <p className="text-[#50555C] text-center max-w-xl mx-auto mb-10">
          Schedule a pickup, we match you with a local provider, and deliver
          your clothes back clean and ready.
        </p>
        <div className="max-w-4xl mx-auto">
          <FeatureList features={featureListData} />
        </div>
      </div>

      {/* Services teaser */}
      <div className="mx-4 md:mx-6 lg:mx-14 py-8 md:py-12">
        <div className="rounded-2xl bg-[#F6FCFF] border border-[#1D6076]/10 p-6 md:p-10">
          <h2 className="text-xl md:text-2xl font-bold text-[#023B64] mb-6">
            Wash & Fold · Dry Cleaning · Tailoring
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <h3 className="font-semibold text-[#1E1F21] mb-2">Wash & Fold</h3>
              <FeatureList features={featureListData.slice(0, 1)} />
            </div>
            <div>
              <h3 className="font-semibold text-[#1E1F21] mb-2">Dry Cleaning</h3>
              <FeatureList features={DryCleanListData.slice(0, 1)} />
            </div>
            <div>
              <h3 className="font-semibold text-[#1E1F21] mb-2">Tailoring</h3>
              <FeatureList features={TailoringListData.slice(0, 1)} />
            </div>
          </div>
        </div>
      </div>

      {/* Why choose us - reuse existing component */}
      <div className="mx-4 md:mx-6 lg:mx-14 py-6 md:py-12">
        <WhyChooseUs />
      </div>

      {/* CTA banner - same style as home */}
      <div
        className="mx-4 md:mx-6 lg:mx-14 mb-10"
        style={{
          backgroundImage: `url(${homeBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex w-full justify-center items-center flex-col text-center min-h-[180px] md:min-h-[200px] rounded-2xl gap-2 md:gap-3 lg:gap-4 py-8">
          <p className="text-[#50555C] font-[700] text-base md:text-lg">
            Schedule today to
          </p>
          <h2 className="text-lg md:text-[30px] lg:text-[40px] font-extrabold text-[#023B64] mb-3">
            Get $20 off your first order
          </h2>
          <button
            type="button"
            onClick={() => navigate("/auth/account")}
            className="inline-flex items-center justify-center rounded-lg text-white bg-[#02537F] hover:bg-sky-800 px-5 py-2.5 text-base font-bold shadow-sm transition"
          >
            Schedule your first pickup
          </button>
        </div>
      </div>

      <div className="bg-[#034F78]">
        <Footer />
      </div>
    </div>
  );
}
